import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './HeroHeader.css';
// bgMusic is now managed in App.js

const HeroHeader = ({ isSoundOn, togglePlay }) => {
    const heroWrapperRef = useRef(null);

    const { scrollYProgress } = useScroll({
        target: heroWrapperRef,
        offset: ["start start", "end start"]
    });

    const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);
    const contentOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
    const contentScale = useTransform(scrollYProgress, [0, 0.5], [1, 0.8]);
    const swipeIndicatorOpacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            window.scrollTo({
                top: element.offsetTop,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div 
            ref={heroWrapperRef} 
            className="hero-wrapper"
        >
            <motion.div
                className="hero-background"
                style={{ y: backgroundY }}
            />
            
            {/* Top Navigation Links */}
            <motion.nav
                className="top-nav"
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, delay: 0.5 }}
            >
                <span onClick={() => scrollToSection('details')}>Details</span>
                <span onClick={() => scrollToSection('rsvp')}>RSVP</span>
                <span onClick={() => scrollToSection('gallery')}>Gallery</span>
            </motion.nav>

            <motion.div
                className="hero-content"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                style={{
                    opacity: contentOpacity,
                    scale: contentScale
                }}
            >
                <div className="status-pill">
                    WE'RE GETTING MARRIED
                </div>

                <h1 className="couple-names">Sandeepani & Ruwanara</h1>

                <p className="wedding-date">May 28, 2026 & June 06, 2026 </p>
            </motion.div>

            <motion.div
                className="swipe-indicator"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2, duration: 1 }}
                style={{ opacity: swipeIndicatorOpacity }}
                onClick={() => scrollToSection('quote-section')}
            >
                <span>Swipe up for more</span>
                <span className="chevron">⌄</span>
            </motion.div>

            {/* Floating Music Toggle */}
            <motion.div
                className="music-toggle"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 2.5, type: "spring" }}
                onClick={(e) => {
                    // Prevent any potential bubbling
                    e.stopPropagation(); 
                    togglePlay();
                }}
            >
                <span className="music-icon">{isSoundOn ? '🔊' : '🔇'}</span>
            </motion.div>
        </div>
    );
};

export default HeroHeader;
